<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>

    <div class="main-content" style="padding: 15px; margin: 5px;width: -webkit-fill-available;">
        <div class="rights-wise-login">
            <div class="main-heading">
                <h1>Registration User</h1>
            </div>
            <div class="container-fluid rights-login-wise">
                <form [formGroup]="userForm">
                    <div class="form-row">
                        <div class="form-group">
                            <label>Email:</label>
                            <input type="email" formControlName="email" autocomplete="off" required />
                            <div *ngIf="isFieldInvalid('email')" class="error-message">
                                Email is required and must be a valid email address.
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Password:</label>
                            <div style="display: flex;justify-content: center;">
                                <input [type]="isPasswordVisible ? 'text' : 'password'" formControlName="password"
                                    autocomplete="new-password" required />
                                <button (click)="togglePasswordVisibility()" class="eye-icon">
                                    <i [ngClass]="isPasswordVisible ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                                </button>
                            </div>
                            <div *ngIf="isFieldInvalid('password')" class="error-message">
                                Password is required and must be at least 6 characters long.
                            </div>
                        </div>
                        <div class="form-group">
                            <label>User Type:</label>
                            <select formControlName="user_type">
                                <option value="admin">Admin</option>
                                <option value="user">User</option>
                            </select>
                            <div *ngIf="isFieldInvalid('user_type')" class="error-message">
                                User type is required.
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group">
                            <label>Sidebar Access:</label>
                            <p-multiSelect [options]="sidebarAccessOptions" formControlName="selectedSidebarAccess"
                                [(ngModel)]="selectedSidebarOption" optionLabel="name"
                                placeholder="Select Sidebar Access" [autoWidth]="false" [style]="{'width':'100%'}" />
                        </div>
                        <div class="form-group" *ngIf="SearchMoleculeSelected()">
                            <label>Page Access:</label>
                            <p-multiSelect [options]="pageAccessOptions" formControlName="selectedPageAccess"
                                optionLabel="name" placeholder="Select Page Access" [autoWidth]="false"
                                [style]="{'width':'100%'}" />
                        </div>
                        <div class="form-group" *ngIf="isLMSSelected()">
                            <label>LMS Access:</label>
                            <p-multiSelect [options]="lmsAccessOptions" formControlName="selectedLmsAccess"
                                optionLabel="name" placeholder="Select LMS Access" [autoWidth]="false"
                                [style]="{'width':'100%'}" />
                        </div>
                        <div class="form-group" *ngIf="isLMSDBSelected()">
                            <label>Sections:</label>
                            <p-multiSelect [options]="sectionDropdownOptions" optionLabel="name"
                                formControlName="selectedSection" placeholder="Select Section"
                                [style]="{'width':'100%'}" (onChange)="onSectionChange($event)">
                            </p-multiSelect>
                        </div>
                        <div class="form-group" *ngIf="selectedSection && selectedSection.length > 0">
                            <label>Fields:</label>
                            <p-multiSelect [options]="getFieldsForSections(selectedSection)" optionLabel="name"
                                formControlName="selectedFields" placeholder="Select Fields" [style]="{'width':'100%'}">
                            </p-multiSelect>
                        </div>
                    </div>

                    <div class="form-row submit-buttons">
                        <button *ngIf="!isEditing" type="submit" class="btn btn-primary" [disabled]="isEditing"
                            (click)="onSubmit()">
                            Submit
                        </button>

                        <!-- <buton *ngIf="isEditing" type="button" class="btn btn-success" (click)="onUpdate()">
                            Update
                        </buton> -->

                        <button *ngIf="isEditing" type="button" class="btn btn-success" (click)="showUpdateDialog()">
                            Update
                        </button>

                        <button *ngIf="isEditing" type="button" class="btn btn-secondary" (click)="onCancel()">
                            Cancel
                        </button>
                    </div>
                </form>
            </div>

            <div class="registered-user">
                <div class="registered-user-heading">
                    <h1>Registered Users</h1>
                </div>
                <p-table [value]="userData" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 20, 50]">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Email</th>
                            <th>User Type</th>
                            <th>SideBar Accesses</th>
                            <th>Page Accesses</th>
                            <th>LMS Accesses</th>
                            <th>LMS Section Accesses</th>
                            <th>LMS Field Accesses</th>
                            <th>Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-user>
                        <tr>
                            <td>{{ user.email }}</td>
                            <td>{{ user.user_type }}</td>
                            <td>{{ getAccessList(user.sidebar_access) }}</td>
                            <td>{{ getAccessList(user.page_access) }}</td>
                            <td>{{ getAccessList(user.lms_access) }}</td>
                            <td>{{ getAccessList(user.lms_sections_access) }}</td>
                            <td>{{ getAccessList(user.lms_field_access) }}</td>
                            <td>
                                <div class="operation-buttons">
                                    <button class="btn btn-success" (click)="onEdit(user)">Edit</button>
                                    <!-- <button class="btn btn-danger"
                                        (click)="onDelete(user.id, user.email)">Delete</button> -->
                                    <button class="btn btn-danger"
                                        (click)="showDeleteDialog(user.id, user.email)">Delete</button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <p-dialog header="Confirm Delete" [(visible)]="displayDeleteDialogBox" [modal]="true"
                    [closable]="false">
                    <p>Are you sure you want to delete this record?</p>
                    <p-footer>
                        <button type="button" pButton icon="pi pi-times" label="No" (click)="onCancelDelete()"></button>
                        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="confirmDelete()"></button>
                    </p-footer>
                </p-dialog>

                <p-dialog header="Confirm Update" [(visible)]="displayUpdateDialogBox" [modal]="true"
                    [closable]="false">
                    <p>Are you sure you want to update this record?</p>
                    <p-footer>
                        <button type="button" pButton icon="pi pi-times" label="No" (click)="onCancelUpdate()"></button>
                        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="confirmUpdate()"></button>
                    </p-footer>
                </p-dialog>
            </div>
        </div>
    </div>

</div>